'use strict'

define [], () ->
  ($rootScope, $scope, $http, RentappService, $uibModalInstance) ->
    $scope.is_loading = false
    $scope.first_name = ""
    $scope.last_name = ""
    $scope.routing_number = ""
    $scope.account_number = ""
    $scope.confirm_account_number = ""
    $scope.show_check_info = false

    $scope.toggle_check_info = () ->
      $scope.show_check_info = !$scope.show_check_info

    $scope.link_stripe_account = () ->
      # TODO: Show error 
      if $scope.confirm_account_number != $scope.account_number 
        return
      $uibModalInstance.close({
        first_name: $scope.first_name,
        last_name: $scope.last_name,
        routing_number: $scope.routing_number,
        account_number: $scope.account_number
      })


// WEBPACK FOOTER //
// ./components/dashboard/referral/modals/stripe_link.coffee